import { render, staticRenderFns } from "./PdpSummaryTab.vue?vue&type=template&id=885503fc&scoped=true"
import script from "./PdpSummaryTab.vue?vue&type=script&lang=js"
export * from "./PdpSummaryTab.vue?vue&type=script&lang=js"
import style0 from "./PdpSummaryTab.vue?vue&type=style&index=0&id=885503fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885503fc",
  null
  
)

export default component.exports